import { render, staticRenderFns } from "./MyWay.vue?vue&type=template&id=7b4ea4aa&scoped=true"
import script from "./MyWay.vue?vue&type=script&lang=js"
export * from "./MyWay.vue?vue&type=script&lang=js"
import style0 from "./MyWay.vue?vue&type=style&index=0&id=7b4ea4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ea4aa",
  null
  
)

export default component.exports